import React,{useState} from 'react';
import thubanil1 from '../../assets/img/feed-imgs/right/happening-now/right-img1.png';
import thubanil2 from '../../assets/img/feed-imgs/right/happening-now/right-img2.png';
import thubanil3 from '../../assets/img/feed-imgs/right/happening-now/right-img3.png';


const RecentPosts = () => {
    const [ showDataStatus, setShowDataStatus ] = useState(false)
    const recentPosts = [
        {
            postDesc : "Lorem ipsum dolor sit amet, conse adipiscing elit. Placerat efficitur tincidunt.", 
            author: "Richa Lee",
            dataOfPost: "On 27th Nov",
            thumbnail: thubanil1,
        },
        {
            postDesc : "Lorem ipsum dolor sit amet, conse adipiscing elit. Placerat efficitur tincidunt.", 
            author: "Richa Lee",
            dataOfPost: "On 27th Nov",
            thumbnail: thubanil2
        },
        {
            postDesc : "Lorem ipsum dolor sit amet, conse adipiscing elit. Placerat efficitur tincidunt.", 
            author: "Richa Lee",
            dataOfPost: "On 27th Nov",
            thumbnail: null
        },
        {
            postDesc : "Lorem ipsum dolor sit amet, conse adipiscing elit. Placerat efficitur tincidunt.", 
            author: "Richa Lee",
            dataOfPost: "On 27th Nov",
            thumbnail: thubanil3
        },
        {
            postDesc : "Lorem ipsum dolor sit amet, conse adipiscing elit. Placerat efficitur tincidunt.", 
            author: "Richa Lee",
            dataOfPost: "On 27th Nov",
            thumbnail: null
        },{
            postDesc : "Lorem ipsum dolor sit amet, conse adipiscing elit. Placerat efficitur tincidunt.", 
            author: "Richa Lee",
            dataOfPost: "On 27th Nov",
            thumbnail: thubanil3
        },{
            postDesc : "Lorem ipsum dolor sit amet, conse adipiscing elit. Placerat efficitur tincidunt.", 
            author: "Richa Lee",
            dataOfPost: "On 27th Nov",
            thumbnail: thubanil2
        },
        {
            postDesc : "Lorem ipsum dolor sit amet, conse adipiscing elit. Placerat efficitur tincidunt.", 
            author: "Richa Lee",
            dataOfPost: "On 27th Nov",
            thumbnail: null
        },
    ]
    const lessRecntData = [
        {
            postDesc : "Lorem ipsum dolor sit amet, conse adipiscing elit. Placerat efficitur tincidunt.", 
            author: "Richa Lee",
            dataOfPost: "On 27th Nov",
            thumbnail: thubanil1,
        },
        {
            postDesc : "Lorem ipsum dolor sit amet, conse adipiscing elit. Placerat efficitur tincidunt.", 
            author: "Richa Lee",
            dataOfPost: "On 27th Nov",
            thumbnail: thubanil2
        },
        {
            postDesc : "Lorem ipsum dolor sit amet, conse adipiscing elit. Placerat efficitur tincidunt.", 
            author: "Richa Lee",
            dataOfPost: "On 27th Nov",
            thumbnail: null
        }
    ]

    const handlePostData = () =>{
        setShowDataStatus(!showDataStatus)
    }

    return (
        <div>
            {
                lessRecntData.map( (item, index) => <div key={index} className='row mb-5'>
                    <div className="col-8">
                        <span className="txt_wa">{item.postDesc}</span>
                        <div className="mt-1">
                                <span className="txt_hbd me-1">By</span><span className="txt_name me-2">{item.author}</span><span className="txt_hbd">·&nbsp;{item.dataOfPost}</span></div>
                    </div>
                    <div className="col-4 d-flex justify-content-end align-items-center">
                        <img className="w-100" src={item.thumbnail} alt="" />
                    </div>
                </div>
                    )
            } 
            {
               showDataStatus &&  recentPosts.map( (item, index) => <div key={index} className='row mb-5'>
                 <div className="col-8">
                     <span className="txt_wa">{item.postDesc}</span>
                     <div className="mt-1">
                             <span className="txt_hbd me-1">By</span><span className="txt_name me-2">{item.author}</span><span className="txt_hbd">·&nbsp;{item.dataOfPost}</span></div>
                 </div>
                 <div className="col-4 d-flex justify-content-end align-items-center">
                     <img className="w-100" src={item.thumbnail} alt="" />
                 </div>
             </div>
                 )
            }
            <div className="row">
                <div className="col-12">
                    {
                        showDataStatus ? <span className="login_link cursor-pointer" onClick={handlePostData}>Less then</span> : <span className="login_link cursor-pointer" onClick={handlePostData}>Show more</span>
                    }
                    
                </div>
            </div>
        </div>  
    );
};

export default RecentPosts;